import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom'
import { $ } from "react-jquery-plugin";
import ImgSuccess from '../../images/trophy.jpg'
import ImgFail from '../../images/fail-min.png'
import { useLocation, useNavigate } from "react-router-dom";
import Userimg2 from '../../assets/userimg.png'


const MessageScreen = () => {


    const [ result, setResult ] = useState('')
    let coachName = localStorage.getItem('coachname');

    const navigate = useNavigate();

    useEffect(()=>{
        $('body').removeClass('').addClass('sidebar-collapsed');
        const getItems = JSON.parse(localStorage.getItem("passstatus"))

        setResult(getItems)

        if(!getItems){
            navigate('/select_rule')
        }

        localStorage.removeItem("passstatus")


    },[])

    let token = "Bearer "+localStorage.getItem('token');
    let tokens = localStorage.getItem('token');
    let resetPassword = () => {
        navigate('/reset_password')
    }
    const Logout = () => {
        let urole = localStorage.getItem('userrole');
        localStorage.removeItem('coachlogin');

        if(urole === 'SUPERADMIN'){
            localStorage.removeItem('token');
            localStorage.removeItem('username');
            localStorage.removeItem('userid');
            localStorage.removeItem('userrole');
            localStorage.removeItem('test_attempted')
            localStorage.removeItem('association')
            localStorage.removeItem('coachId')

           
            navigate("/admin")

        }else{
        let store = localStorage.getItem('token');
        // console.log('key',store)
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('userid');
        localStorage.removeItem('userrole');
        localStorage.removeItem('test_attempted')
        localStorage.removeItem('association')

        
        navigate("/rules_list", { replace: true });
        }
        //window.location.href = "gisa/";
      }

    return(
        <div>
            <aside class="right-side areas success-area"  style={{background:'#fff'}}>
            {
                tokens?
            (<header>
				<div className="title-and-userprofile-wrpr" >
                    <div>
                        
                    </div>
					<div className="user-profile-wrpr nav navbar-nav">
						<div className="navbar-collapse">
                            <div className="navbar">
                            
                                <ul className="nav user-profile navbar-nav ml-auto text-right">
                                    <ul className="nav-item user-avatar-items dropdown">
                                        <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="/aaa">
                                                        
                                            <div className="username-and-type">
                                                <span className="loggedinuser">
                                                    <i className="icon-userimage"></i> <span className="username">User</span>
                                                </span>
                                                <span className="usertype">{coachName}</span>
                                            </div>
                                            <div className="profile-pic">
                                                <img src={Userimg2} width="" height="" alt="" />
                                            </div>
                                                            
                                        </a>	

                                        <div className="dropdown-menu dropdown-menu-right">
                                            <button className="dropdown-item" onClick={ resetPassword }>Reset Password</button>
                                            <button onClick={Logout} className="dropdown-item" href="#">Logout</button>											
                                        </div>
                                    </ul>
                                </ul>
                            </div>
                        </div> 
                    </div>
                </div>
			</header> ) : null
            }
                {result.message === "passed"?
                <div class="content-area dash-contentss">
                    <div className="success-text">
                        <img className="successimg" src={ImgSuccess} width="28%" />
                    </div>
                    <div className="success-text">
                        <h6 style={{fontFamily:'Poppins', textAlign:'center', color:'green', fontWeight:600}}>Congratulations you have passed successfully</h6>
                    </div>

                    <div className="success-text">
                        <h6 style={{fontFamily:'Poppins', textAlign:'center', color:'green', fontWeight:600}}>You have scored {result.userMark} out of {result.totalMark}</h6>
                    </div>

                    <div className="success-text">
                        <div className="row success-btn" style={{ width:"30%", marginTop:20}}>
                            <div className="col-md-5">
                                <button
                                    onClick={()=>{navigate('/select_rule')}} 
                                    style={{padding:15, width:"100%", display:'flex', justifyContent:'center', background:'#f1f1f1', color:'#0068ff', fontFamily:'Poppins', fontWeight:800, borderRadius:10}}><i style={{paddingTop:"4px"}} className="icon-home4"></i>&nbsp;&nbsp;&nbsp;&nbsp;Home</button>
                            </div>
                            <div className="col-md-7 sec-btn">
                                <button
                                    onClick={()=>{navigate('/certificate/'+result.id)}}
                                 style={{padding:15, width:"100%", display:'flex', justifyContent:'center', background:'#0068ff', color:'#fff', fontFamily:'Poppins', fontWeight:800, borderRadius:10}}><i style={{paddingTop:"4px"}} className="icon-download8"></i>&nbsp;&nbsp;&nbsp;&nbsp;Download Certificate</button>
                            </div>
                        </div>
                    </div>

                </div>:


                <div class="content-area dash-contentss">
                    <div className="success-text">
                        <img className="successimg" src={ImgFail} width="20%" />
                    </div>
                    <div className="success-text">
                        <h6 style={{fontFamily:'Poppins', textAlign:'center', color:'red', fontWeight:600}}>Unfortunately you have failed</h6>
                    </div>

                    <div className="success-text">
                        <h6 style={{fontFamily:'Poppins', textAlign:'center', color:'red', fontWeight:600}}>You have scored {result.userMark} out of {result.totalMark}</h6>
                    </div>

                    <div className="success-text">
                        <div className="row success-btn" style={{ width:"30%", marginTop:20}}>
                            <div className="col-md-12">
                                <button
                                onClick={()=>{navigate('/select_rule')}} 
                                style={{padding:15, width:"100%", display:'flex', justifyContent:'center', background:'#0068ff', color:'#fff', fontFamily:'Poppins', fontWeight:800, borderRadius:10}}><i style={{paddingTop:"4px"}} className="icon-home4"></i>&nbsp;&nbsp;&nbsp;&nbsp;Home</button>
                            </div>
                        </div>
                    </div>

                </div>}

            </aside>
        </div>

    )
}

export default MessageScreen;